/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import PropTypes from "prop-types";

function Label({
  className: _className = null,
  ...props
}) {
  const className = [_className, "block mb-2"].filter(Boolean).join(" ");

  return <label className={className} {...props} />;
}

Label.propTypes = {className: PropTypes.string, htmlFor: PropTypes.string.isRequired};

export default Label;
